import { SupplierGroupMessage } from '../../../../../types/SupplierGroupMessage';
import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { useRole } from '../../../../common/hooks/useRole';
import { Box } from '../../../../common/ui/Box';

import { SpotPortAvailability } from './SpotPortAvailability';

interface SpotPortAvailabilityTabsProps {
    groupId: string;
    supplierGroup: SupplierGroupMessage;
}

export const SpotPortAvailabilityTabs = ({ groupId, supplierGroup }: SpotPortAvailabilityTabsProps) => {
    const role = useRole();

    const hasLubes =
        supplierGroup.spotAllowed &&
        supplierGroup.lubesSettings.spotAllowed &&
        (role.hasAdminRights() || role.isSuperAdmin());

    return (
        <>
            {hasLubes ? (
                <Box display="flex" flexDirection="column" gap={16}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Text variant="subtitle1" as="h2">
                            {translate('company.lubesSpotPortAvailability')}
                        </Text>
                    </Box>
                    <SpotPortAvailability groupId={groupId} spotSettings={supplierGroup.lubesSettings} />
                </Box>
            ) : null}
        </>
    );
};
